import { render, staticRenderFns } from "./DisputeViewServices.vue?vue&type=template&id=a41ad6c4&"
import script from "./DisputeViewServices.vue?vue&type=script&lang=js&"
export * from "./DisputeViewServices.vue?vue&type=script&lang=js&"
import style0 from "./DisputeViewServices.vue?vue&type=style&index=0&id=a41ad6c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports